import { ReactNode } from "react";

export type PageHeaderProps = {
  brand: ReactNode;
  actions?: ReactNode[];
};

export default function Header({ brand, actions }: PageHeaderProps) {
  return (
    <header className="fl-fixed fl-top-0 fl-left-0 fl-right-0 fl-flex fl-items-center fl-justify-between fl-px-4 fl-py-3 fl-bg-light fl-bg-gradient-to-r fl-from-primary fl-to-secondary fl-text-white">
      <span className="fl-text-xl fl-font-light">{brand}.</span>
      {actions && (
        <div className="fl-flex fl-items-center fl-space-x-4">{actions}</div>
      )}
    </header>
  );
}
